import React from 'react'
import DashboardComponent from '../Components/Dashboard/DashboardComponent'

function DashboardPage() {
    return (

        <DashboardComponent/>
    )
}

export default DashboardPage